import React, { useCallback } from "react";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { Tooltip } from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";

import { replaceUnderscoreAndCapitalize } from "../../../../../../../utils";
import { ButtonIcon } from "../../../../../../../components/Buttons/ButtonIcon/ButtonIcon";
import { iFrameCssClasses } from "../../../../../components/IFramePanel/hooks/useIframeCommand";
import useScrollToIframeElement from "../../hooks/useScrollToIframeElement";

import styles from "./styles.module.scss";

const TemplateSelectors = ({
    currentIframeRef,
    currentIframeWrapperRef,
    templateSelectors,
    onEditTemplateSelector,
    onDeleteTemplateSelector,
    getPathTo,
    getElementsByText,
    highlightElement,
    clearCssClassName
}) => {
    const scrollToElement = useScrollToIframeElement(currentIframeRef, currentIframeWrapperRef);

    const handleMouseEnter = useCallback(
        (selector, type_code) => {
            if(type_code === "XPATH") {
                highlightElement(selector, iFrameCssClasses.active);

                scrollToElement(selector);
            }

            if(type_code === "NONE") {
                const elements = getElementsByText(selector);
                const xPaths = getPathTo(elements);
                scrollToElement(xPaths);

                highlightElement(xPaths, iFrameCssClasses.active);
            }
        },
        [ getElementsByText, getPathTo, highlightElement, scrollToElement ]
    );

    const handleMouseLeave = useCallback(
        () => {
            clearCssClassName(iFrameCssClasses.active);
        },
        [ clearCssClassName ]
    );

    if(!templateSelectors?.length) {
        return null;
    }

    return (
        <div className={styles.templateSelectorList}>
            {
                templateSelectors?.map(({ source_code, condition_code, type_code, selector }, index) => (
                    <div
                        key={index}
                        className={styles.templateSelector}
                    >
                        <div className={styles.name}>
                            {replaceUnderscoreAndCapitalize(source_code)},&nbsp;
                            {replaceUnderscoreAndCapitalize(condition_code)},&nbsp;
                            {replaceUnderscoreAndCapitalize(type_code)},&nbsp;

                            <Tooltip title={selector}>
                                <b>{selector}</b>
                            </Tooltip>
                        </div>

                        <div className={styles.commands}>
                            {
                                (type_code === "XPATH" || type_code === "NONE") && (
                                    <div
                                        className={styles.view}
                                        onMouseEnter={() => handleMouseEnter(selector, type_code)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <VisibilityIcon />
                                    </div>
                                )
                            }

                            <ButtonIcon
                                title={"Edit"}
                                onClick={() => onEditTemplateSelector(index)}
                            >
                                <EditIcon/>
                            </ButtonIcon>

                            <ButtonIcon
                                warning
                                title={"Delete"}
                                onClick={() => onDeleteTemplateSelector(index)}
                            >
                                <DeleteIcon/>
                            </ButtonIcon>
                        </div>
                    </div>
                ))
            }
        </div>
    );
};

export default TemplateSelectors;
